import React from 'react'
import Activities from '../../../../../../modules/Activities'
import Diary from '../../../../../../modules/Diary'
import { Card, CardDrawer } from '../../../../../../components/Card'
import Button from '../../../../../../components/inputs/Button'
import Icon from '../../../../../../components/Icon'
import InfoBar from '../../../../../../modules/InfoBar'

const Parameters = ({ grpid, infoBar, parameters }) => {
    return (
        <>
            {
                infoBar &&
                <InfoBar
                    lastUpdate={infoBar.lastUpdate}
                    translation={infoBar.translation}
                    noContainer
                />
            }
            {
                parameters.heatmonitoring &&
                <Card>
                    <CardDrawer
                        name='Monitoring rui'
                        value='tryb automatyczny'
                        renderOpenButton={({ handleToggleIsOpenDrawer }) => <Button noMargin onClick={handleToggleIsOpenDrawer}><Icon name='edit' /></Button>}
                    />
                </Card>
            }
            {
                parameters.activities && parameters.calendar &&
                <Activities
                    activities={parameters.activities}
                    calendar={parameters.calendar}
                />
            }
            {
                parameters.diary &&
                <Diary
                    id={grpid}
                    endpointDiary='/rpc/get_grp_alerts'
                    endpointNote=''
                    diary={parameters.diary}
                    disableAddNote
                />
            }
        </>
    )
}

export default Parameters
